<style scoped>
  .post-wrapper {
    padding-top:60px;
    height: 120vh;
    width: 100%;
    background-color: #fff;
  }
  .post-body {
    background-color: #fff;
    overflow: auto;
    padding: 15px;
    height: 100%;
    flex: 1;
  }
  .card {
    border-radius: 0;
    cursor: pointer;
    border-bottom: 1px solid #F2F2F2;
    min-height: 60px;
    margin-bottom: 10px;
  }
  .post-line {
    display: flex;
    margin-bottom: 10px;
  }
  post-col1 {
    display: flex;
  }
  .post-col2 {
    padding-left: 10px;
    width: 100%;
  }
  .status {
    font-size:10px;
  }
</style>


<template>
  <app-layout class="post-wrapper">
    <div class="post-body">
      <Card v-for="(like, i) in likes" class="card" :key="i" :bordered="false" dis-hover :padding="0">
        <div class="post-line">
          <div class="post-col1">
            <router-link tag="div" :to="'/profile/'+ like.id">
              <Avatar size="large" :src="like.avatar"></Avatar>
            </router-link>
          </div>
          <div class="post-col2">
            <p>
              <router-link tag="div" :to="'/profile/'+ like.id">
                <b style="color:black;"> {{ like.display_name }} </b>
              </router-link>
            </p>
            <p class="status">
              <timeago :since="like.updated_at"></timeago>
            </p>
          </div>
        </div>
      </Card>

    </div>
  </app-layout>
</template>


<script>

export default {
  name: 'LikesComponent',
  computed: {
    activities: {
      get() {
        return this.$store.state.feed.feedSingleItemActivities.activities;
      }
    },
    likes: {
      get() {
        var index = this.$route.params.index;
        var indexReply = this.$route.params.indexReply;
        console.log(indexReply);

        if (indexReply==='undefined') {
          console.log("like reply is undefined")
          return this.activities[index].likes.users;
        } else {
          console.log("like reply is defined")
          return this.activities[index].comment.comments[indexReply].likes.users;
        }
      }
    }
  }
}

</script>
